import { useMemo } from 'react'
import { useWallet } from '../../../hooks/useWallet'
import metamaskIcon from '../assets/metamask.svg'
import okxIcon from '../assets/okx.svg'
import trustIcon from '../assets/trust.svg'
import type { IconKey } from '@rhinofi/dvf-shared-ui'

const OTHER_WALLETS: {
  image?: string
  icon?: IconKey
  label: string
}[] = [
  {
    image: metamaskIcon,
    label: 'MetaMask',
  },
  {
    image: okxIcon,
    label: 'OKX Wallet',
  },
  {
    image: trustIcon,
    label: 'Trust Wallet',
  },
  {
    icon: 'wallet',
    label: 'Browser wallet',
  },
]

export const useOtherWallet = () => {
  const wallet = useWallet()

  return useMemo(() => {
    return OTHER_WALLETS.filter(
      ({ label }) => !wallet.eip6963Providers.some((provider) => provider.info.name === label),
    )
  }, [wallet.eip6963Providers])
}
